export { default } from './DollarAmount';



// WEBPACK FOOTER //
// ./app/components/borrowing/shared/DollarAmount/index.js